/* The Mint Workshop — sticky CTA.
   Docks above the header on phones once you have scrolled past the top of the
   page. Rendered from the layout, so it appears on every page rather than only
   the one containing the hero.

   Position is measured on scroll rather than watched with an observer: an
   observer holds a reference to one element, and if that element is removed or
   hidden — a section reload, a client-side page change — it keeps reporting the
   last state and the bar sticks open. Re-querying each time survives that.

   Fails open: if the bar is missing the page behaves normally. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-mw-stickycta]');
  if (!bar) return;

  var mq = window.matchMedia('(max-width: 900px)');
  var fallbackAt = parseInt(bar.dataset.fallback || '520', 10);
  var docked = false;

  function measure() {
    // the header offset has to match the bar's real height, not an estimate
    document.documentElement.style.setProperty('--stickycta-h', bar.offsetHeight + 'px');
  }

  function dock(on) {
    if (on === docked) return;
    docked = on;
    bar.classList.toggle('is-on', on);
    document.body.classList.toggle('mw-cta-docked', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (on) measure();
  }

  function arm(on) {
    bar.classList.toggle('is-armed', on);
    if (on) {
      measure();
      requestAnimationFrame(measure);
    } else {
      dock(false);
    }
  }

  function evaluate() {
    if (!mq.matches) { dock(false); return; }

    // Prefer the page's own primary button when it has one, so the bar takes
    // over exactly where that button leaves the screen.
    var src = document.querySelector('[data-mw-cta-source]');
    if (src && src.offsetParent !== null) {
      dock(src.getBoundingClientRect().bottom < 0);
    } else {
      dock(window.pageYOffset > fallbackAt);
    }
  }

  arm(mq.matches);
  evaluate();

  window.addEventListener('scroll', evaluate, { passive: true });
  window.addEventListener('resize', function () {
    if (mq.matches) measure();
    evaluate();
  }, { passive: true });

  (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function (e) {
    arm(e.matches);
    evaluate();
  });
})();
